import React from 'react'
import { RadioItem } from 'common/types'
import axios from 'axios'
import { isDevelopment } from 'common/utils'


type PullDownJsonType = { [key: string]: string[] }

type ScoringContextType = {
  pullDownJson: PullDownJsonType
  fetchPulldown: () => Promise<void>
  getRadioItems: (key: string) => RadioItem[]
}

export const ScoringContext = React.createContext<ScoringContextType | undefined>(undefined)

export const ScoringProvider = ({children}: React.PropsWithChildren) => {

  const [pullDownJson, setPullDownJson] = React.useState<PullDownJsonType>({})

  const fetchPulldown = async (): Promise<void> => {
    if (Object.keys(pullDownJson).length > 0) return
    const filename = isDevelopment ? 'pulldown_dev.json' : 'pulldown.json'
    const response = await axios.get(`https://dznfxuvgky742.cloudfront.net/config/${filename}`)
    if (response.status === 200) {
      setPullDownJson(response.data)
    }
  }

  const getRadioItems = (key: string): RadioItem[] => {
    const items = pullDownJson[key]
    if (items === undefined) {
      return []
    } else {
      return items.map((item) => ({
        value: item,
        label: item.replace(/\r?\n/g, '')
      }))
    }
  }


  const value = React.useMemo(() => ({
    pullDownJson,
    fetchPulldown,
    getRadioItems,
  }), [
    pullDownJson,
    fetchPulldown,
    getRadioItems,
  ])

  return (
    <ScoringContext.Provider value={value}>
      {children}
    </ScoringContext.Provider>
  )
}
